import {
  type AnimateLayoutChanges,
  defaultAnimateLayoutChanges,
  useSortable
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type React from 'react'

export type BaseReorderableItemProps = {
  id: string | number
}

export interface ReorderableItemProps extends BaseReorderableItemProps {
  className?: string
  children?: React.ReactNode
  handler?: boolean
  isDragDisabled?: boolean
}

// this is for insert / delete animation
// not working
const animateLayoutChanges: AnimateLayoutChanges = (args) => {
  const { isSorting, wasDragging } = args

  if (isSorting || wasDragging) {
    return defaultAnimateLayoutChanges(args)
  }

  return true
}

export function ReorderableItem(props: ReorderableItemProps) {
  const {
    id,
    className,
    children,
    isDragDisabled = false,
    handler = false
  } = props
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      disabled: isDragDisabled,
      animateLayoutChanges
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  }

  const atributesAndListeners = handler
    ? {}
    : {
        ...attributes,
        ...listeners
      }

  return (
    <div
      id={id.toString()}
      className={className}
      ref={setNodeRef}
      style={style}
      {...atributesAndListeners}
    >
      {children}
    </div>
  )
}
